var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('v-col',{attrs:{"cols":"12","lg":"8","offset-lg":"2"}},[_c('h1',[_vm._v("You are not authorized to view the resource")]),_c('div')])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }